var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormulateInput',{attrs:{"label":"Pohlaví","type":"select","name":"sex","value":_vm.value,"options":{ M: 'Mužské', F: 'Ženské' },"help":_vm.help,"error-behavior":"submit","disabled":_vm.disabled}})
}
var staticRenderFns = []

export { render, staticRenderFns }